<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>Accounts</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right">
                   
                     <!-- <button type="button" class="btn btn-info"><i class="fas fa-file"></i> IMPORT DATA</button> -->
                    <!-- <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                        <i @click="searchCustomer()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchCustomer" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>               -->
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >ECN</th>
                                    <th 
                                    scope="col" 
                                    class="sort"
                                   >ACCOUNT NO</th>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >ACCOUNT KEY</th>  
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="accounts.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="account in accounts" :key="account.id">
                                <td>{{account.ecn}}</td>
                                <td>{{account.account}}</td>
                                <td>{{account.accountValue}}</td>
                               
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
  name: "imstradingaccountComponent",
  data() {
    return {
        accessToken:null,
        loading : false,
        accounts : []
     
    };
  },
  methods: {
    getAccounts(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/account/list?ecn=IBP,TMC,TWD,MKTX&status=ACTIVE",
            auth
        )
        .then(result => {
          this.accounts = result.data;
          this.loading = false;

        })        
    },
    updateAccount(account){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .put(
            config.baseUrlBidSide +
            "/account?cognitoSub="+authService.getUser().cognitoSub,
            account,
            auth
        )
        .then(() => {
            this.$alert("Account Updated","","success");
            this.loading = false;
        }).catch(() => this.loading = false) 
    }

   
  },
  mounted() {
    this.getAccounts();
  }
};
</script>